module.exports = __webpack_public_path__ + "fonts/Pretendard-ExtraLight.70e0ae6c.woff";